// src/components/common/tableHeadCellSx.ts

import type { Theme } from '@mui/material';

/**
 * Canonical styling for a hand-built table's header cell (`<TableCell>` inside
 * a `<TableHead>`). The label typography is the single source of truth
 * `theme.custom.table.headCell`; this helper also pins the header background and
 * hairline border so sticky headers stay opaque and match the react-admin
 * datagrids.
 *
 * Usage:
 *   import { tableHeadCellSx } from '@/components/common/tableHeadCellSx';
 *   <TableCell sx={tableHeadCellSx}>…</TableCell>
 *   <TableCell sx={[tableHeadCellSx, { width: 50 }]}>…</TableCell>  // with extras
 */
export const tableHeadCellSx = (t: Theme) => ({
  ...t.custom.table.headCell,
  backgroundColor: t.custom.table.headerBg,
  borderBottom: `1px solid ${t.custom.table.headerBorder}`,
});
